"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
/**
 * Adapts standard DOM window history to work with our
 * { replace, push } interface.
 *
 * @param history Standard history provided by DOM
 */
function adaptWindowHistory(history) {
    return {
        replace(location) {
            history.replaceState(location.state, '', `${location.protocol}//${location.host}${location.pathname}${location.search}`);
        },
        push(location) {
            history.pushState(location.state, '', `${location.protocol}//${location.host}${location.pathname}${location.search}`);
        },
    };
}
/**
 * Adapts @reach/router history to work with our
 * { replace, push } interface.
 *
 * @param history globalHistory from @reach/router
 */
function adaptReachHistory(history) {
    return {
        replace(location) {
            history.navigate(`${location.protocol}//${location.host}${location.pathname}${location.search}`, { replace: true });
        },
        push(location) {
            history.navigate(`${location.protocol}//${location.host}${location.pathname}${location.search}`, { replace: false });
        },
    };
}
/**
 * Helper to produce the context value falling back to
 * window history and location if not provided.
 */
function getContextValue(contextValue = {}) {
    const value = Object.assign({}, contextValue);
    const hasWindow = typeof window !== 'undefined';
    if (hasWindow) {
        if (!value.history) {
            value.history = adaptWindowHistory(window.history);
        }
        if (!value.location) {
            value.location = window.location;
        }
    }
    return value;
}
exports.QueryParamContext = React.createContext(getContextValue());
/**
 * Context provider for query params to have access to the
 * active routing system, enabling updates to the URL.
 */
function QueryParamProvider({ children, ReactRouterRoute, reachHistory, history, location, }) {
    // if we have React Router, use it to get the context value
    if (ReactRouterRoute) {
        return (React.createElement(ReactRouterRoute, null, (routeProps) => {
            return (React.createElement(exports.QueryParamContext.Provider, { value: getContextValue(routeProps) }, children));
        }));
    }
    // if we are using reach router, use its history
    if (reachHistory) {
        return (React.createElement(exports.QueryParamContext.Provider, { value: getContextValue({
                history: adaptReachHistory(reachHistory),
                location,
            }) }, children));
    }
    // neither reach nor react-router, so allow manual overrides
    return (React.createElement(exports.QueryParamContext.Provider, { value: getContextValue({ history, location }) }, children));
}
exports.QueryParamProvider = QueryParamProvider;
exports.default = QueryParamProvider;
